var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import camelCase from "lodash/camelCase";
import pluralize from "pluralize";
import { CREATE, DELETE, GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE, UPDATE, } from "react-admin";
import { makePrefixedFullName } from "./makePrefixedFullName";
export var makeIntrospectionOptions = function (options) {
    var _a, _b, _c, _d, _e, _f;
    var prefix = function (s) { return makePrefixedFullName(s, options === null || options === void 0 ? void 0 : options.aliasPrefix); };
    var mutationOperationNames = __assign({ "nexus-prisma": (_a = {},
            _a[CREATE] = function (resource) { return prefix("createOne" + resource.name); },
            _a[UPDATE] = function (resource) { return prefix("updateOne" + resource.name); },
            _a[DELETE] = function (resource) { return prefix("deleteOne" + resource.name); },
            _a), "pothos-prisma": (_b = {},
            _b[CREATE] = function (resource) { return prefix("createOne" + resource.name); },
            _b[UPDATE] = function (resource) { return prefix("updateOne" + resource.name); },
            _b[DELETE] = function (resource) { return prefix("deleteOne" + resource.name); },
            _b), typegraphql: (_c = {},
            _c[CREATE] = function (resource) { return prefix("create" + resource.name); },
            _c[UPDATE] = function (resource) { return prefix("update" + resource.name); },
            _c[DELETE] = function (resource) { return prefix("delete" + resource.name); },
            _c) }, options.mutationOperationNames);
    var queryOperationNames = __assign({ "nexus-prisma": (_d = {},
            _d[GET_LIST] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _d[GET_ONE] = function (resource) { return prefix("" + camelCase(resource.name)); },
            _d[GET_MANY] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _d[GET_MANY_REFERENCE] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _d), "pothos-prisma": (_e = {},
            _e[GET_LIST] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _e[GET_ONE] = function (resource) { return prefix("" + camelCase(resource.name)); },
            _e[GET_MANY] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _e[GET_MANY_REFERENCE] = function (resource) {
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _e), typegraphql: (_f = {},
            _f[GET_LIST] = function (resource) {
                var pluralName = pluralize(resource.name);
                if (resource.name === pluralName) {
                    return prefix("findMany" + resource.name);
                }
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _f[GET_ONE] = function (resource) {
                var pluralName = pluralize(resource.name);
                if (resource.name === pluralName) {
                    return prefix("findUnique" + resource.name);
                }
                return prefix("" + camelCase(resource.name));
            },
            _f[GET_MANY] = function (resource) {
                var pluralName = pluralize(resource.name);
                if (resource.name === pluralName) {
                    return prefix("findMany" + resource.name);
                }
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _f[GET_MANY_REFERENCE] = function (resource) {
                var pluralName = pluralize(resource.name);
                if (resource.name === pluralName) {
                    return prefix("findMany" + resource.name);
                }
                return prefix("" + pluralize(camelCase(resource.name)));
            },
            _f) }, options.queryOperationNames);
    return __assign({ operationNames: __assign(__assign({}, queryOperationNames[options.queryDialect]), mutationOperationNames[options.queryDialect]), exclude: undefined, include: undefined }, options.introspection);
};
//# sourceMappingURL=makeIntrospectionOptions.js.map